import { createAction } from '@reduxjs/toolkit';

export const querystringLoaded = createAction('[Querystring] querystringLoaded');
